import { PARENT_WINDOW_SIZE } from 'scripts/type'

const isSmScreen = (size: PARENT_WINDOW_SIZE | null) => size === PARENT_WINDOW_SIZE.SM

export default isSmScreen
